import * as React from "react";

export const SvgArrowLeft = ({ color = "#595959", ...props }) => (
	<svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" color={color} {...props}>
		<path
			d="M4.5 8.343c0-.246.095-.491.282-.679l5.897-5.897a.96.96 0 1 1 1.358 1.358L6.82 8.343l5.218 5.218a.96.96 0 0 1-1.358 1.358L4.782 9.022a.958.958 0 0 1-.281-.679Z"
			fill="currentColor"
		/>
	</svg>
);
